import { ContentSort, ContentSortFields } from "@/shared/services/graphql/generated/consumer-graph-types.ts";
import { SortEntry } from "@/shared/components/sort-dropdown/sort-dropdown.model.ts";

/**
 * Narrows a sort entry of the shared sort dropdown to a content sort. The dropdown is used by every
 * ability, so its field type covers the sort fields of all entities. A field that the content schema
 * does not know is dropped, because sending it would make the whole query fail.
 *
 * @param sort - The sort entry selected by the user, if any.
 * @returns The matching content sort, or `undefined` if there is none.
 */
export const toContentSort = (sort?: SortEntry): ContentSort | undefined => {
    if (!sort || !Object.values(ContentSortFields).includes(sort.field as ContentSortFields)) return undefined;

    return { field: sort.field as ContentSortFields, order: sort.order };
};
